import { DatePipe, isPlatformBrowser } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild, ChangeDetectorRef, AfterContentChecked, AfterViewChecked } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DatepickerDateCustomClasses, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import * as globalConstant from '../../global_constant';
import { Subscription } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { MainService } from '../../main.service';
import { MessageService } from '../../message.service';
import { ToastrService } from '../../services/toastr.service';
import { LocationService } from '../../services/location.service';
import { FindCouple } from '../../services/findcouple.service';
import { VisitorsService } from '../../services/Visitors.service';
import { Experience } from '../../services/experience.service';
import { PageSectionService } from '../../services/PageSection.service';
import { SharedModule } from '../../share/shared.module';
import { AutoCompleteModule, AutoComplete } from 'primeng/autocomplete';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgZone } from '@angular/core';
import { CanonicalService } from 'src/app/services/canonical.service';
import { GalleriaModule, Galleria } from 'primeng/galleria';


@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [
    AutoCompleteModule,
    NgxSkeletonLoaderModule,
    GalleriaModule,
    SharedModule
  ],

  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.css',

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomepageComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('videoElement', { static: false }) videoElement: ElementRef;
  mobBannerView: any = "";
  is_mobile_view: boolean = false;
  private _picker: BsDatepickerDirective;
  loading = false;
  isBrowser: boolean;
  section_data: any;
  spurExperience: any;
  section_image_url = '';
  authUser: any;
  base_website_url: string = '';
  wedding_registry_background: any = ''
  circleData: any = {};
  wedding_registry: any = {}
  popularDestinations: any = [];
  popularCategories: any = [];
  autocompleteExpResults: any = [];
  autocompleteCoupleResults: any = [];
  autocompleteCategoryResults: any = []
  tokenkey: any = '';
  see_world_section: any = {};
  download_app_section: any = {}
  selected_state_name = '';
  ipAddress: any;
  ip_location: any;
  iplocation: any;
  home_experience: any;
  date_value: any = '';
  minDate = new Date();
  maxDate: Date
  nowTime: Date
  latitude: number;
  longitude: number;
  dateCustomClasses: DatepickerDateCustomClasses[];
  location: any = 0
  timePipeString: string;
  datePipeString: string;
  SubscribeForm: FormGroup;
  submitted = false;
  certificate_data: any = '';
  clickCart: any = '';
  subscribe_error_message: any = '';
  subscribe_error = false;
  home_exp_length: any = '';
  home_slider: any = '';
  exp_slug: any = '';
  couple_slug: any = '';
  category_slug: any = ''
  selected_location: any = '';
  country_List: any = [];
  state_List: any = [];
  nearBySearch: any = {}
  country_id: any = globalConstant?.default_country;
  tikTokUrl: any = globalConstant?.OWNER_TIK_TOK_URL;
  instagramUrl: any = globalConstant?.OWNER_INSTAGRAM_URL;
  enable_rfp_224: any = globalConstant?.ENABLE_RFP_224;
  web_cdn_url: String = globalConstant?.WEB_CDN_URL;
  subscription: Subscription;
  home_gift_card: any = [];
  gift_data_first_name: any;
  gift_data_second_name: any;
  isLive: any = globalConstant?.IS_LIVE;
  home_mobile_banner: any;
  mobBannerImage: string = "";
  banner_video: any = ''
  autocompleteLocationResults: any = [];
  location_booking: any = "";
  categoryList: any = [];
  mobBannerVideo: string = "";
  exp_image_url: string = '';
  location_image_url: string = '';
  category_image_url: string = '';
  autocomplete_search: string;
  autocomplete_search_to: any
  autocomplete_couple_search: string
  results: string[];
  autocomplete_location_search: string = "";
  location_id: Number = 0;
  exp_title_search: string;
  page_data: any;
  searchExp: any
  gift_experiences_data: any = {}
  guest_about_spur: any = {}
  home_url: string = globalConstant?.WEBSITE_URL;
  static EMAIL: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  selectedDate: any;
  selectedDateRange: any
  searchHistory: any[] = [];
  continuePlanningData: any[] = [];
  isCookies: boolean;
  showRecentSearches: boolean = false;
  isOpenDatePicker: any = false
  isOpenDatePickerMobile: any = false
  address: string;
  city: string;
  selectedNearby: any = false;
  anyPrice: string = "Any Price";
  isBoat: boolean;
  siteUrl: String = globalConstant?.WEBSITE_URL;
  pageUrl: any = '';

  seasonalPromotionsData: any;
  images: any[] | undefined;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  @ViewChild('autoCompleteRef') autoComplete!: AutoComplete;
  enteredValue: string = "";

  constructor(
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private titleService: Title,
    private mainService: MainService,
    private messageService: MessageService,
    public toastr: ToastrService,
    public router: Router,
    public locationService: LocationService,
    private findCouple: FindCouple,
    private visitorService: VisitorsService,
    private experienceService: Experience,
    private pageSectionService: PageSectionService,
    private metaService: Meta,
    @Inject(PLATFORM_ID) platformId: Object,
    private cdref: ChangeDetectorRef,
    private canonicalService: CanonicalService,
    private ngZone: NgZone
  ) {
    let currenturl = this.router.url;
    let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
    const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
    this.pageUrl = canonicalUrl;
    this.canonicalService.setCanonical(canonicalUrl);
    this.setGlobalPassiveEvents();
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      window.scrollTo(0, 0);
      this.isBoat = this.isSitePerformanceBoat();
    }
    if (this.isBrowser) {
      if (window.innerWidth < 768) {
        this.is_mobile_view = true;
      } else {
        this.is_mobile_view = false;
      }
    }
    if (this.isBrowser) {
			window.addEventListener('resize', this.updateScreenSize.bind(this));
		}
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    if (this.isBrowser) {
      if (localStorage.getItem('login_token')) {
        this.tokenkey = localStorage.getItem('login_token');
      }
      if (localStorage.getItem('authUser')) {
        this.authUser = JSON.parse(localStorage.getItem('authUser'));
      }
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.isBrowser) {
          document.querySelector("body").classList.remove("overflow");
        }
      }
    });
    if (this.isBrowser) {

      if (localStorage.getItem('temporary_charity_gallery_url')) {
        localStorage.removeItem('temporary_charity_gallery_url');
      }
    }
    const now = new Date();
    this.dateCustomClasses = [
      { date: now, classes: ['bg-warning', 'text-white'] },
    ];

    this.nowTime = new Date();
    this.timePipeString = datePipe.transform(Date.now(), 'h:mm a');
    this.datePipeString = datePipe.transform(Date.now(), 'yyyy-MM-dd');
  }

  updateScreenSize() {
		if (this.isBrowser) {
      if (window?.innerWidth < 768) {
        this.is_mobile_view = true;
      } else {
        this.is_mobile_view = false;
      }
		}
	}

  normalizeUrl(url: string): string {
    return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
  }

  isSitePerformanceBoat(): boolean {
    const userAgent = window.navigator.userAgent;
    if (userAgent.includes('GTmetrix') || userAgent.includes('Chrome-Lighthouse')) {
      return true;
    }
    return false;
  }

  autocompleteCoupleSearch(event) {
    this.findCouple.find_couples(1, event?.query, this.tokenkey).subscribe(res => {
      if (res?.response == 'success') {
        this.autocompleteCoupleResults = res?.data?.data?.data;
      } else {
        this.autocompleteCoupleResults = [];
      }
    });
  }
  autocompleteCategorySearch(event) {
    this.experienceService.experiencesCategory(event?.query).subscribe(res => {
      if (res?.response == 'success') {
        this.autocompleteCategoryResults = res?.data;
      } else {
        this.autocompleteCategoryResults = [];
      }
    });
  }
  searchExpName() {
    this.router.navigate(['/experience-name-search'], { queryParams: { title: this.searchExp } });
  }
  onSelectAutocompleteSearch(event, isMobile) {
    this.autocomplete_search_to = event?.value;
    this.exp_slug = event?.value?.value.trim();
    if (event?.value?.type == 'exp') {
      if (this.exp_slug) {
        if (isMobile) {
          this.router.navigateByUrl('/experiences/' + this.exp_slug).then(() => {
            if (this.isBrowser) {
              window.location.reload();
            }
          });
        } else {
          this.router.navigate(['/experiences/' + this.exp_slug]);
        }

      }
    } else {
      isMobile ? this.isOpenDatePickerMobile = true : this.isOpenDatePicker = true
    }
  }

  onClickSearch() {
    this.router.navigate(['/experience-name-search'], { queryParams: { title: this.autocomplete_search } })
  }

  nearby(isMobile) {
    this.selectedNearby = true;
    this.visitorService.getCurrent_location_nearBy().then((res: any) => {
      console.log(res, "resresresresresres")
      if (res?.address && res?.address?.address_components) {
        let city = '';
        let addressComponents = res?.address?.address_components;

        // Iterate through address components to find the city
        for (let i = 0; i < addressComponents?.length; i++) {
          let types = addressComponents[i]?.types;

          if (types.includes('locality')) {
            city = addressComponents[i]?.long_name;
            break;
          } else if (!city && types.includes('administrative_area_level_3')) {
            city = addressComponents[i]?.long_name;
          } else if (!city && types.includes('administrative_area_level_2')) {
            city = addressComponents[i]?.long_name;
          }
        }

        if (city) {
          this.city = city;
        }
        if (this.isBrowser) {

          if (typeof addressComponents[3] != 'undefined' && addressComponents[3]?.long_name != 'undefined') {
            let iploc = {};
            this.selected_state_name = addressComponents[3]?.long_name;
            this.selected_location = addressComponents[3]?.long_name;
            iploc['region'] = addressComponents[3]?.long_name;
            this.iplocation = iploc;
            this.autocomplete_search_to = this.city;
            let idElement = isMobile ? document.getElementById('autoCompleteSearchValueMobile') : document.getElementById('autoCompleteSearchValue');
            if (idElement && idElement.querySelector('input')) {
              idElement.querySelector('input').value = this.city;
            }
            isMobile ? this.isOpenDatePickerMobile = true : this.isOpenDatePicker = true;
            this.latitude = res?.lat;
            this.longitude = res?.long;
          }
        }
      }
    }).catch((err) => {
      console.error('Error in nearby function:', err);
      if (err.code === 1) {
        this.toastr.errorToastr("Enable location to see nearby.", 'Error!');
      } else {
        this.toastr.errorToastr("An error occurred while fetching location.", 'Error!');
      }
    });
  }

  onSelectAutocompleteCoupleExperience(event) {
    this.autocomplete_couple_search = event?.value?.couple_full_name;
    this.couple_slug = event?.value?.slug;
    if (this.couple_slug) {
      this.router.navigate(['/registries/' + this.couple_slug]);
    }
  }
  onSelectAutocompleteCategoryExperience(event) {
    console.log(event, 'dfdsfdsf');
    if (event?.value?.type == 'higher-level-category') {
      this.router.navigate(['/experience/' + event?.value?.value]);
    } else {
      this.router.navigate(['/gift-ideas-category/' + event?.value?.value]);
    }

  }

  loadSearchHistory() {
    if (this.isCookies) {
      try {
        if (this.isBrowser) {

          this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
        }
      } catch (e) {
        console.error('Error loading search history:', e);
        this.searchHistory = [];
      }
    }
  }

  loadContinuePlanningData() {
    if (this.isCookies) {
      try {
        if (this.isBrowser) {
          this.continuePlanningData = JSON.parse(localStorage.getItem('searchedExp')) || [];
        }
      } catch (e) {
        console.error('Error loading exp search history:', e);
        this.continuePlanningData = [];
      }
    }
  }

  
  autocompleteSearch(event?: any) {
    let query = event?.query?.trim();
    if (this.enteredValue && this.enteredValue !== '') {
      query = this.enteredValue;
    }
    let requestbody = { 'search': query };
    this.experienceService.searchExperienceAutocomplete(requestbody, this.tokenkey).subscribe(res => {
      if (res?.response == 'success') {
        this.autocompleteExpResults = res?.data;
        if (this.autocompleteExpResults && this.autocompleteExpResults?.length !== 0) {
          this.showRecentSearches = false;
        } else {
          this.showRecentSearches = false;
        }
        this.exp_image_url = res?.exp_image_url;
        this.location_image_url = res?.location_image_url;
        this.category_image_url = res?.category_image_url;
      }
    });
  }

  onFocusSearchBox(event?) {
    if (event && event?.type === "focus") {
      if(this.enteredValue && this.enteredValue !== '') {
        this.showRecentSearches = false;       
        this.autocompleteSearch();   
        setTimeout(() => {
          this.autoComplete.show();
        }, 0);   
      } else {
        this.showRecentSearches = true;
      }
    }
  }

  searchedInput(event) {
    let searchedValue = event?.target?.value?.trim();
    if(searchedValue && searchedValue !== '') {
      this.enteredValue = searchedValue;
    } else {
      this.enteredValue = '';
    }
  }

  onBlurSearchBox(event) {
    setTimeout(() => {
      this.showRecentSearches = false;
    }, 200);
  }

  selectRecentSearch(searchText?: any, isMobile?) {
    this.selectedNearby = false;
    this.autocomplete_search_to = searchText
    this.autocomplete_search_to['label'] = searchText?.title
    if (searchText?.type == 'exp') {
      if (searchText?.params) {
        if (isMobile) {
          this.router.navigate(['/experiences/' + searchText?.params]).then(() => {
            if (this.isBrowser) {
              window.location.reload();
            }
          });
        } else {
          this.router.navigate(['/experiences/' + searchText?.params]);
        }
      }
    } else {
      isMobile ? this.isOpenDatePickerMobile = true : this.isOpenDatePicker = true
    }
    if (this.isBrowser) {
      let idElement = isMobile ? document.getElementById('autoCompleteSearchValueMobile') : document.getElementById('autoCompleteSearchValue')
      idElement.querySelector('input').value = searchText?.title
    }
  }


  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    if (this.isBrowser) {
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
  }

  getCookie(data) {
    if (this.isBrowser) {
      let name = data + "=";

      let ca = document?.cookie?.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }

  onSchedulingDateSelect(event: any) {
    if (event && event.length === 2) {
      const startDate = event[0];
      const endDate = event[1];
      const dateClasses: DatepickerDateCustomClasses[] = [];

      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        dateClasses.push({
          date: new Date(currentDate),
          classes: ['date-range-selected']
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }

      this.dateCustomClasses = dateClasses;
    }
  }

  newSection: OwlOptions = {
    items: 5,
    dots: false,
    nav: true,
    autoplay: false,
    loop: false,
    rewind: true,
    margin: 15,
    navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1
      },
      500: {
        items: 2
      },
      768: {
        items: 3
      },
      992: {
        items: 4.5
      },
      1200: {
        items: 5.5
      }
    }
  }

  popularDestinationOwl = {
    margin: 20,
    items: 5,
    dots: false,
    nav: true,
    autoplay: false,
    loop: false,
    rewind: true,
    navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1
      },
      500: {
        items: 2
      },
      768: {
        items: 3.1
      },
      992: {
        items: 4.5
      },
      1200: {
        items: 5.5
      }
    }
  }

  guestOwl = {
    margin: 20,
    items: 5,
    dots: false,
    nav: false,
    autoplay: true,
    loop: true,
    rewind: true,
    navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1.2
      },
      500: {
        items: 2.2
      },
      768: {
        items: 2.5
      },
      992: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  }

  ngOnInit() {
    this.getAllExperienceData()
    this.loading = true;
    if (this.isBrowser) {
      this.base_website_url = window.location.origin;
    }

    let requestBody = { 'slug': 'home' };
    this.pageSectionService.get_page_data(requestBody).subscribe(res => {
      if (res?.response == "success") {
        this.section_data = res?.data;
        if (this.section_data) {
          this.addMetaTags();
        }
        this.banner_video = res?.data?.video_url
        this.see_world_section = res?.data?.sections[0]
        this.guest_about_spur = res?.data?.sections[1]
        this.gift_experiences_data = res?.data?.sections[2]
        this.circleData = res?.data?.sections[3];
        this.wedding_registry = res?.data?.sections[4];
        this.spurExperience = res?.data?.sections[5];
        this.home_mobile_banner = res?.data?.sections[6];
        this.download_app_section = res?.data?.sections[7];

        this.seasonalPromotionsData = res?.data?.seasonal_promotion_data;
        if (this.seasonalPromotionsData) {
          let seasonalDataImages = this.seasonalPromotionsData?.gallery;
          const galleryImages = seasonalDataImages?.map((item, index) => ({
            itemImageSrc: item?.media,
            thumbnailImageSrc: item?.media,
            alt: item?.button_text || `Image ${index + 1}`,
            title: item?.button_text || `Title ${index + 1}`,
            buttonText: item?.button_text,
            buttonUrl: item?.button_url,
            heading: item?.title,
            subHeading: item?.description
          })) || [];

          if (galleryImages) {
            this.images = galleryImages;
          }
        }
        
        this.popularDestinations = res?.extra_data['location_list'];
        this.popularCategories = res?.extra_data['category_list'];
        this.section_image_url = res?.image_url;
        this.certificate_data = res['gift_certificate'];
        this.wedding_registry_background = this.is_mobile_view && this.wedding_registry?.section_data?.length > 0 && this.wedding_registry?.section_data[0]?.image_url ? this.wedding_registry?.section_data[0]?.image_url : this.wedding_registry?.image_url
      }
    });

    let requestbody1 = { 'location': this.iplocation?.region };
    this.experienceService.homepage_exp_by_location(requestbody1, this.tokenkey).subscribe(res => {
      if (res?.response == 'success') {
        this.home_experience = res?.data;
        this.home_exp_length = Object.keys(this.home_experience)?.length;
      }
    });

    this.visitorService.getCurrent_location().then((res: any) => {
      if (typeof res?.address != 'undefined' && typeof res?.address?.address_components != 'undefined' && typeof res?.address?.address_components[3] != 'undefined' && typeof res?.address?.address_components[3]?.long_name != 'undefined') {

        let iploc = {};

        this.selected_state_name = res?.address?.address_components[3]?.long_name;
        this.selected_location = res?.address?.address_components[3]?.long_name;
        iploc['region'] = res?.address?.address_components[3]?.long_name;
        this.iplocation = iploc;

        let requestbody = { 'location': this.iplocation.region };
        this.experienceService.homepage_exp_by_location(requestbody, this.tokenkey).subscribe(res => {
          if (res?.response == 'success') {
            this.home_experience = res?.data;
            this.home_exp_length = Object.keys(this.home_experience)?.length;
          }
        });
      }
    });

    this.SubscribeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(HomepageComponent.EMAIL)]],
    });
    this.messageService.sendAutocompleteSearchParameterMessage({ 'search_type': 'search-autocomplete' });

   /*  if(this.isBrowser && this.isLive) {
      let isBoat = this.isSitePerformanceBoat();
      if (!isBoat) {
        // this.load_facebook_script();
      }
    } */

    this.isCookies = this.getCookie('acceptCookies') !== "";
    this.loadSearchHistory();
    this.loadContinuePlanningData();
  }

  get subscribeFormCtrl() {
    return this.SubscribeForm.controls;
  }

  ngAfterViewInit() {
    this.loading = false;
    if (this.isBrowser) {
      var brodPopup = document.getElementById("popup-broadcast")
      if (brodPopup != null && brodPopup != undefined) {
        brodPopup.classList.add('open');

        document.querySelector(".close-broadcast").addEventListener("click", (e) => {
          brodPopup.classList.remove('open');
        });
      }
    }
  }

  closeVideoPopup(event) {
    if (this.isBrowser) {
      var veboBody = document.getElementById("vebo_body");
      veboBody.classList.remove('videoPopup-hidden');
      document.getElementById('video-popup-wrapper').hidden = true;
      var videoFarme = document.getElementById('videoIframe');
      videoFarme.removeAttribute("src");
    }
  }

  mobileView(eve) {
    this.mobBannerView = eve;
    this.location_booking = "";
    if (eve == 'bookNow_view') {
      this.mobBannerImage = this.home_mobile_banner?.section_data[0]?.image_url;
      this.mobBannerVideo = this.home_mobile_banner?.section_data[0]?.video_url;
      this.videoElement?.nativeElement?.load();
    } else if (eve == 'gift_view') {
      this.mobBannerImage = this.home_mobile_banner?.section_data[1]?.image_url;
      this.mobBannerVideo = this.home_mobile_banner?.section_data[1]?.video_url;
      this.videoElement?.nativeElement?.load();
    } else if (eve == 'wedding_view') {
      this.mobBannerImage = this.home_mobile_banner?.section_data[2]?.image_url;
      this.mobBannerVideo = this.home_mobile_banner?.section_data[2]?.video_url;
      this.videoElement?.nativeElement?.load();
    } else {
      this.mobBannerImage = this.section_image_url + 'home_sections/' + this.home_mobile_banner?.image;
      this.mobBannerVideo = this.home_mobile_banner?.video_url;
      this.videoElement?.nativeElement?.load();
    }
    if (this.isBrowser) {
      window.scrollTo(0, 0);
    }
  }

  onSubscribeSubmit() {
    this.submitted = true;
    this.loading = true;
    this.subscribe_error = false;
    this.subscribe_error_message = '';

    // stop here if form is invalid
    if (this.SubscribeForm.invalid) {
      this.loading = false;
      return;
    } else {

      let reuestBody = { 'email': this.SubscribeForm.get('email').value.replace(/^\s+|\s+$/gm, '') };
      this.mainService.subscribeUser(reuestBody).subscribe(res => {
        if (res?.response == "success") {
          this.loading = false;
          this.SubscribeForm.controls['email'].setValue('');
          this.toastr.successToastr(res?.message, "Success")
          // this.router.navigate(['/thanksforsubscribing']);
          this.submitted = false;
        } else {
          this.loading = false;
          this.subscribe_error = true;
          this.subscribe_error_message = res?.message;

        }
      });
    }
  }

  add_gift_certificate() {
    this.messageService.sendGiftCertificate(this.certificate_data)
  }

  getAllExperienceData() {
    this.subscription = this.messageService.getAutocompleteSearchParameterMessage().subscribe(messageData => {
      this.exp_slug = messageData?.data_slug;
      if (this.exp_slug)
        this.router.navigate(['/experiences/' + this.exp_slug])
    })
  }

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    if (this.isBrowser) {
      const hoverWrapper = (hoverEvent) => {
        const { cell, isHovered } = hoverEvent;
        if ((isHovered &&
          !!navigator.platform &&
          /iPad|iPhone|iPod/.test(navigator.platform)) &&
          'ontouchstart' in window
        ) {
          (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
        }

        return dayHoverHandler(hoverEvent);
      };
      // event.dayHoverHandler = hoverWrapper;
      const touchHandler = (event) => hoverWrapper(event);
      document.addEventListener('touchstart', touchHandler, { passive: true });
    }
  }

  search_clear() {
    this.autocompleteExpResults = [];
  }

  search_couple_clear() {
    this.autocompleteCoupleResults = [];
  }

  search_category_clear() {
    this.autocompleteCategoryResults = [];
  }

  ngOnDestroy() {
    if (this.subscription != undefined && this.subscription != null) {
      this.subscription.unsubscribe();
    }
  }

  onResize(event) {
    if (event.target.innerWidth < 768) {
      this.is_mobile_view = true;
    } else {
      this.is_mobile_view = false;
    }
  }


  clearDate() {
    this.selectedDateRange = [];
  }


  clearRecentSearch() {
    this.searchHistory = []
    if (this.isBrowser) {
      if (localStorage.getItem('searchHistory')) {
        localStorage.removeItem('searchHistory')
      }
    }
  }

  clearRecentSearchedExp() {
    this.continuePlanningData = []
    if (this.isBrowser) {
      if (localStorage.getItem('searchedExp')) {
        localStorage.removeItem('searchedExp')
      }
    }
  }

  ngAfterViewChecked() {
    this.cdref.detectChanges();
  }

  onSelectAutocompleteExperience(event, isClick = false, isMobile = false) {
    this.exp_slug = event?.value;
    if (!isClick) {
      if (!event && !this.autocomplete_search) {
        this.router.navigate(['/experience-name-search'])
      } else if (!event?.label && this.autocomplete_search) {
        this.router.navigate(['/experience-name-search'], { queryParams: { title: this.autocomplete_search } })
      }
    } else {
      if (!event) {
        this.router.navigate(['/experience-name-search'])
      } else if (!event?.label) {
        this.router.navigate(['/experience-name-search'], { queryParams: { title: event } })
      }
    }
    switch (event?.type) {
      case "exp":
        if (this.exp_slug) {
          this.router.navigate(['/experiences/' + this.exp_slug]);
          // set close
        }
        break;
      case "location-list":
      case "location":
        if (event?.country_slug == null && event?.state_slug == null) {
          this.router.navigate(['/location-region/' + (this.exp_slug ? this.exp_slug : event?.params)], {
            queryParams: {
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
              end_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
            }
          });
        } else if (event?.country_slug == null && event?.state_slug != null) {
          this.router.navigate(['/location-region/' + (this.exp_slug ? this.exp_slug : event?.params)], {
            queryParams: {
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
              end_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
            }
          });
        } else if (event?.country_slug != null && event?.state_slug != null) {
          this.router.navigate(['/location-region/' + event.state_slug + '/' + (this.exp_slug ? this.exp_slug : event?.params)], {
            queryParams: {
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
              end_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
            }
          });
        }
        break;
      case "higher-level-category":
      case "category":
        if (isClick) {
          if (event?.id && event?.id != '') {
            this.router.navigate(['/experience/' + (this.exp_slug ? this.exp_slug : event?.params)]);
          } else {
            this.router.navigate(['/experience-name-search'], {
              queryParams: {
                title: event.label,
                search_id: event.id,
                type: event.type,
                start_date: this.datePipe.transform(this.selectedDateRange?.length > 0 ? this.selectedDateRange[0] : '', 'yyyy-MM-dd'),
                end_date: this.datePipe.transform(this.selectedDateRange?.length > 1 ? this.selectedDateRange[1] : '', 'yyyy-MM-dd')
              }
            });
          }
        } else {
          this.router.navigate(['/experience-name-search'], {
            queryParams: {
              title: this.autocomplete_search,
            }
          });
        }
        break;
      case undefined:
        if (isClick && this.selectedNearby === false) {
          let idElement = isMobile ? document.getElementById('autoCompleteSearchValueMobile') : document.getElementById('autoCompleteSearchValue')

          this.router.navigate(['/experience-name-search'], {
            queryParams: {
              title: idElement.querySelector('input').value ? idElement.querySelector('input').value : '',
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              start_date: this.datePipe.transform(this.selectedDateRange?.length > 0 ? this.selectedDateRange[0] : '', 'yyyy-MM-dd'),
              end_date: this.datePipe.transform(this.selectedDateRange?.length > 1 ? this.selectedDateRange[1] : '', 'yyyy-MM-dd')
            }
          });
        } else if (isClick && this.selectedNearby === true && event && this.city !== undefined && this.city !== null) {
          this.router.navigate(['/location-region/' + this.city], {
            queryParams: {
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              latitude: this.latitude,
              longitude: this.longitude,
              start_date: this.datePipe.transform(this.selectedDateRange?.length > 0 ? this.selectedDateRange[0] : '', 'yyyy-MM-dd'),
              end_date: this.datePipe.transform(this.selectedDateRange?.length > 1 ? this.selectedDateRange[1] : '', 'yyyy-MM-dd')
            }
          });

        } else {
          this.router.navigate(['/experience-name-search'], {
            queryParams: {
              title: this.autocomplete_search,
            }
          });
        }
        break;
    }
  }

  onSelectRedirect(event, isClick = false, isMobile = false) {
    this.exp_slug = event?.value;
    if (!isClick) {
      if (!event && !this.autocomplete_search) {
        this.router.navigate(['/experience-name-search'])
      } else if (!event?.label && this.autocomplete_search) {
        this.router.navigate(['/experience-name-search'], { queryParams: { title: this.autocomplete_search } })
      }
    } else {
      if (!event) {
        this.router.navigate(['/experience-name-search'])
      } else if (!event?.label) {
        this.router.navigate(['/experience-name-search'], { queryParams: { title: event } })
      }
    }
    switch (event?.type) {
      case "exp":
        if (this.exp_slug) {
          this.router.navigate(['/experiences/' + this.exp_slug]);
          // set close
        }
        break;
      case "location-list":
      case "location":
        if (event?.country_slug == null && event?.state_slug == null) {
          this.router.navigate(['/location-region/' + (this.exp_slug ? this.exp_slug : event?.params)], {
            queryParams: {
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
              end_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
            }
          });
        } else if (event?.country_slug == null && event?.state_slug != null) {
          this.router.navigate(['/location-region/' + (this.exp_slug ? this.exp_slug : event?.params)], {
            queryParams: {
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
              end_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
            }
          });
        } else if (event?.country_slug != null && event?.state_slug != null) {
          this.router.navigate(['/location-region/' + event.state_slug + '/' + (this.exp_slug ? this.exp_slug : event?.params)], {
            queryParams: {
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              start_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '',
              end_date: this.selectedDateRange?.length > 0 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : ''
            }
          });
        }
        break;
      case "category":
        if (isClick) {
          this.router.navigate(['/experience-name-search'], {
            queryParams: {
              title: event.label,
              search_id: event.id,
              type: event.type,
              start_date: this.datePipe.transform(this.selectedDateRange?.length > 0 ? this.selectedDateRange[0] : '', 'yyyy-MM-dd'),
              end_date: this.datePipe.transform(this.selectedDateRange?.length > 1 ? this.selectedDateRange[1] : '', 'yyyy-MM-dd')
            }
          });
        } else {
          this.router.navigate(['/experience-name-search'], {
            queryParams: {
              title: this.autocomplete_search,
            }
          });
        }
      case undefined:
        if (isClick && this.selectedNearby === false) {

          this.router.navigate(['/experience-name-search'], {
            queryParams: {
              title: event?.label ? event?.label : '',
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              start_date: this.datePipe.transform(this.selectedDateRange?.length > 0 ? this.selectedDateRange[0] : '', 'yyyy-MM-dd'),
              end_date: this.datePipe.transform(this.selectedDateRange?.length > 1 ? this.selectedDateRange[1] : '', 'yyyy-MM-dd')
            }
          });
        } else if (isClick && this.selectedNearby === true && event && this.city !== undefined && this.city !== null) {
          this.router.navigate(['/location-region/' + this.city], {
            queryParams: {
              is_booking: this.selectedDateRange?.length > 0 ? 1 : 0,
              latitude: this.latitude,
              longitude: this.longitude,
              start_date: this.datePipe.transform(this.selectedDateRange?.length > 0 ? this.selectedDateRange[0] : '', 'yyyy-MM-dd'),
              end_date: this.datePipe.transform(this.selectedDateRange?.length > 1 ? this.selectedDateRange[1] : '', 'yyyy-MM-dd')
            }
          });

        } else {
          this.router.navigate(['/experience-name-search'], {
            queryParams: {
              title: this.autocomplete_search,
            }
          });
        }
        break;
    }
  }

  getImageUrl(imageUrl: string, index: number): string {
    if (index < 3) {
      return `${imageUrl}?width=150`;
    } else if (index < 6) {
      return `${imageUrl}?height=565`;
    } else if (index < 9) {
      return `${imageUrl}?width=150`;
    } else {
      return imageUrl;
    }
  }

  setGlobalPassiveEvents() {
    this.ngZone.runOutsideAngular(() => {
      if (this.isBrowser) {
        const passiveEvents = ['touchstart', 'touchmove', 'wheel', 'scroll'];
        passiveEvents.forEach((eventType) => {
          window.addEventListener(eventType, () => { }, { passive: true });
        });
      }
    });
  }

  addMetaTags() {
    this.titleService.setTitle(globalConstant.SITE_TITLE_SLUG + this.section_data?.title)
    this.metaService.updateTag({ property: 'og:title', content: this.section_data?.title });
    this.metaService.updateTag({ property: 'og:url', content: this.pageUrl });
    this.metaService.updateTag({ property: 'og:image', content: this.section_data?.image_url });
    this.metaService.updateTag({ property: 'og:description', content: this.section_data?.meta_description });
    this.metaService.updateTag({ property: 'description', content: this.section_data?.meta_description });
  }

  redirectToUrl(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
